module.exports = __webpack_public_path__ + "media/images/icon-checkbox-off-5a3117b0392c09a1618b6963a22fdb7c.svg";